<template>
<div class="chapter">
<div class="inner_page">
<p class="block_8"><span class="text_4">Copyright © Michael Kinnamon, 2021</span></p>
<p class="block_6"> </p>
<p class="block_8"><span class="text_4">All rights reserved under International and Pan-American Copyright Conventions. Published by Publerati.</span></p>
<p class="block_6"> </p>
<p class="block_8"><span class="text_4">This book is a work of fiction. Names, characters, businesses, organizations, places, events, and incidents are either the product of the author’s imagination or are used fictitiously. Any resemblance to actual persons, living or dead, events, or locales is entirely coincidental.</span></p>
<p class="block_6"> </p>
<p class="block_8"><span class="text_4">Cover design by William </span><span class="text_5">Oleszczuk</span></p>
<p class="block_6"> </p>
<p class="block_8"><span class="text_4">Trade Paperback ISBN: 978-0-9979137-5-0</span></p>
<p class="block_8"><span class="text_4">Ebook ISBN: 978-0-9979137-6-7</span></p>
<p class="block_6"> </p>
<p class="block_8"><span class="text_4">Publerati donates a portion of all sales to help spread literacy. Please learn more at </span><a class="text_6" href="https://www.publerati.com/" target="_blank">publerati.com</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_002.vue?aca3864e